<template>
    <component :is="tag">
        <slot v-bind="this.feedback"></slot>
    </component>
</template>

<script>
    import hasInputs from '../mixins/has-inputs';
    export default {
        name: 'VFeedback',
        mixins: [
            hasInputs,
        ],
        props: {
            tag: {
                type: String,
            },
        },
        computed: {
            feedback() {
                // TODO: Подумать над каким-нибудь свойством с priority (например, чтобы отображать либо строку, либо массив, при необходимости)
                return this.inputs.reduce((feedback, input) => {
                    return feedback.concat(Array.isArray(input.feedback) ? input.feedback : []);
                }, []).flat();
            }
        },
        provide() {
            return {
                $feedback: this,
            };
        },
    }
</script>